module.exports = __webpack_public_path__ + "static/media/chrome.6fd7372b.svg";